import { render, staticRenderFns } from "./OdocTable.vue?vue&type=template&id=24bd26cb"
import script from "./OdocTable.vue?vue&type=script&lang=js"
export * from "./OdocTable.vue?vue&type=script&lang=js"
import style0 from "./OdocTable.vue?vue&type=style&index=0&id=24bd26cb&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports